
import React, { PureComponent } from 'react';
import { AJAX_REQUEST, AJAX_PUBLIC_REQUEST, SET_STORAGE, GET_STORAGE, BUNDLE_OFFER_NEW } from "../../Constants/AppConstants";
import history from '../../history';

class Reorder extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            order_id: this.props.match.params.order_id,
        }
    }

    checkCustomBundleDiscountSettings = async () => {
        let customBundleDiscountSetting = GET_STORAGE('custom_bundle_discount_settings');
        
        if (customBundleDiscountSetting) {
            const normalized = customBundleDiscountSetting.toLowerCase();
            const isEnabled = normalized === 'enable';
            return isEnabled ? 'enable' : 'disable';
        } else {
            try {
                const data = {
                    filter_by: 'popular'
                };
                const results = await AJAX_PUBLIC_REQUEST("POST", "product/getCustomBundleList", data);
                
                if (results.response.code === 1000) {
                    let rawSetting = results.response.custom_bundle_discount_settings;
                    let normalizedSetting = 'disable';
                    if (typeof rawSetting === 'string') {
                        const v = rawSetting.toLowerCase();
                        if (v === 'enable') {
                            normalizedSetting = 'enable';
                        }
                    } else if (rawSetting === 1 || rawSetting === true) {
                        normalizedSetting = 'enable';
                    }
                    
                    SET_STORAGE('custom_bundle_discount_settings', normalizedSetting);
                    
                    if (results.response.order_amount_discount) {
                        SET_STORAGE('orderAmountDiscount', JSON.stringify(results.response.order_amount_discount));
                    }
                    
                    return normalizedSetting;
                } else {
                    return 'disable';
                }
            } catch (error) {
                return 'disable';
            }
        }
    }

    componentDidMount() {
        let data = {
            order_id: this.state.order_id
        }
        AJAX_REQUEST("POST", "order/getReOrderData", data).then(results => {
            if (parseInt(results.response.code) === 1000) {
                let data = results.response.data;
                if (data.supplement) {
                    const hasCustomBundle = data.supplement.some(item => item.is_custom_bundle == 1);
                    if(hasCustomBundle){
                        this.checkCustomBundleDiscountSettings().then((setting) => {
                            const isAmountBased = setting === 'enable';
                            
                            SET_STORAGE("productDiscount", JSON.stringify(data.product_discount));
                            SET_STORAGE('Bundle', JSON.stringify(data.supplement));
                            SET_STORAGE("CustomSubscriptionDetail", JSON.stringify(data.subscription_detail));
                            SET_STORAGE("is_subscription", 'no');
                            
                            if (isAmountBased) {
                                SET_STORAGE('amount_bundle_flow', 'yes');
                                SET_STORAGE('Discount_data', JSON.stringify([]));
                                
                                const products = JSON.parse(GET_STORAGE("Bundle"));
                                const updatedProducts = products.map((product) => {
                                    return {
                                        ...product,
                                        custom_bundle_discount_price: parseFloat(product.cart_sale_price).toFixed(2),
                                        custom_bundle_discount: 0
                                    };
                                });
                                SET_STORAGE("Bundle", JSON.stringify(updatedProducts));
                                SET_STORAGE("BundleCart", JSON.stringify(updatedProducts));
                            } else {
                                SET_STORAGE('amount_bundle_flow', 'no');
                                BUNDLE_OFFER_NEW();
                                let discount_data_new = (GET_STORAGE("Discount_data")) ? JSON.parse(GET_STORAGE("Discount_data")) : '';
                                const products = JSON.parse(GET_STORAGE("Bundle"));
                                const updatedProducts = products.map((product, index) => {
                                    const Inddiscount = discount_data_new[index] || 0; 
                                    const newSalePrice = (product.cart_sale_price - Inddiscount);
                                    return {
                                        ...product,
                                        custom_bundle_discount_price: newSalePrice.toFixed(2),
                                        custom_bundle_discount: Inddiscount.toFixed(2)
                                    };
                                });
                                SET_STORAGE("Bundle", JSON.stringify(updatedProducts));
                            }
                            
                            if (data.meals) {
                                SET_STORAGE('meals', JSON.stringify(data.meals));
                            }
                            history.push('/cart');
                        });
                    } else {
                        SET_STORAGE('cart', JSON.stringify(data.supplement));
                    }
                }
                if (data.meals) {
                    SET_STORAGE('meals', JSON.stringify(data.meals));
                }
                history.push('/cart');
            } else {
                history.push('/my-account/view-order');
            }
        });
    }

    render() {
        return (
            <div className="loading container full_page_loader"></div>
        );
    }
}

export default Reorder;